




































import CountTo from "vue-count-to";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
const water = require("@/assets/water.png");
const power = require("@/assets/power.png");
const gas = require("@/assets/gas.png");
const hot = require("@/assets/hot.png");
const pv = require("@/assets/pv.png");
@Component({
  components: {
    CountTo
  }
})
export default class PanelGroup extends Vue {
  private myColors = ["#40c9c6", "#36a3f7", "#f4516c", "#34bfa3", "#40c9c6"];
  private colors = ["#ffffff", "#ffffff", "#ffffff", "#ffffff", "#ffffff"];
  private icons = [water, power, gas, hot, pv];
  private oldIndex = 0;
  @Prop({ required: true }) private groupData!: any;
  public handleClickPanelGroup(index) {
    this.colors[this.oldIndex] = "#ffffff";
    Vue.set(this.colors, this.oldIndex, this.colors[this.oldIndex]);
    this.oldIndex = index;
    this.colors[index] = this.myColors[index];
    Vue.set(this.colors, index, this.colors[index]);
    this.$emit("handleClickPanelGroup", index);
  }
  public created() {
    this.colors[0] = this.myColors[0];
  }
}
